// extracted by mini-css-extract-plugin
export default {"boxContent":"JP_Environment_boxContent__y+9N8","contentTab":"JP_Environment_contentTab__ySwhb","sliderDesc":"JP_Environment_sliderDesc__j0uWR"};